import { TREE_REPLACEMENT_GRID } from './tree-replacement-styles';
import { labelStyle } from './workshopFields';

const COLUMNS = [
  { area: 'name', label: 'CUSTOMER' },
  { area: 'trees', label: 'TREES' },
  { area: 'note', label: 'NOTES' },
  { area: 'status', label: 'STATUS' },
] as const;

/** Column labels, shown only when the rows are laid out as columns. */
export function TreeReplacementsListHeader() {
  return (
    <div aria-hidden style={{ ...TREE_REPLACEMENT_GRID.columns, padding: '6px 6px 4px' }}>
      {COLUMNS.map((c) => (
        <span key={c.area} style={{ ...labelStyle, gridArea: c.area }}>
          {c.label}
        </span>
      ))}
    </div>
  );
}
